import { ThemeProvider } from '@mui/material/styles';
import { theme as dsTheme } from '@sb/cc-design-system';
import type { PropsWithChildren } from 'react';

export const DesignSystemThemeProvider = ({ children }: PropsWithChildren) => (
  // Use a function so the DS theme doesn't merge with the outer CC-UI theme.
  <ThemeProvider theme={() => dsTheme}>{children}</ThemeProvider>
);

export default DesignSystemThemeProvider;
